/**
 * AI:
 * Status: "confirmed"
 * Type: Service
 * SubType: CrudService
 * Reason: Generic CRUD service for sm.SmChannelTypeNotification, the per-purpose notification
 *   templates of one channel type. One row binds one ns.NsNotificationType to one purpose -
 *   invitation, otp, channelBindingRefused or reminder - so an OTP variant carries two of them.
 *   Registered so the config page's generic table and form can resolve the entity by alias; there is
 *   no dedicated object component, which is what getObjectComponent returning null states.
 */
import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../core/shared/service/crud/mvs-crud-mode.enum';

/**
 * CRUD service for {@link SmChannelTypeNotificationDto}, the per-purpose notification templates of
 * a channel type.
 */
@Injectable({
    providedIn: 'root'
})
export class SmChannelTypeNotificationService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/sm/channelTypeNotifications');
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        return null; // No dedicated object component for this entity;
    }
}
